import { createRoot } from "react-dom/client";
import { useEffect } from "react";

import Box from "@mui/material/Box";

interface EventCaptureWallProps {
  active: boolean;
  setActive: () => void;
}

function EventCaptureWall({ active, setActive }: EventCaptureWallProps) {
  useEffect(() => {
    const element = document.getElementById("eventCaptureWall");
    if (!element) {
      return;
    }

    if (!active) {
      element.innerHTML = "";
      return;
    }

    if (element) {
      const root = createRoot(element);
      root.render(
        <Box
          onClick={setActive}
          sx={{
            position: "fixed",
            inset: 0,
            zIndex: "var(--zIndexEventCaptureWall)",
          }}
        />
      );
    }

    const handleEvent = () => {
      setActive();
      /*
       * for illistrations, cannot fake click event to start sound
      setTimeout(()=>{
        const event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
        })
        window.dispatchEvent(event);
      },3000);
      */
    };

    window.addEventListener("touchstart", handleEvent, { passive: false });
    window.addEventListener("mousewheel", handleEvent, { passive: false });
    return () => {
      window.removeEventListener("touchstart", handleEvent);
      window.removeEventListener("mousewheel", handleEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  return <></>;
}

export default EventCaptureWall;
